// packages
import { useDropzone } from 'react-dropzone'
import { Upload } from 'lucide-react'

// libs
import { cn } from '@/lib/utils'

// interfaces
interface IDropZoneProps {
  onDrop: (files: File[]) => void
  disabled?: boolean
  maxFiles?: number
  multiple?: boolean
  accept?: any
}

export function DropZone({ onDrop, disabled, maxFiles, multiple, accept }: IDropZoneProps) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    disabled,
    maxFiles,
    multiple,
    accept
  })

  return (
    <div
      {...getRootProps()}
      className={cn(
        'border-2 border-dashed rounded-xl p-8 text-center cursor-pointer transition-all',
        isDragActive
          ? 'border-primary bg-primary/15 scale-[1.01]'
          : 'border-primary/50 bg-primary/5 hover:border-primary hover:bg-primary/10',
        disabled && 'opacity-50 cursor-not-allowed'
      )}
    >
      <input {...getInputProps()} />
      <div className="flex-1 flex flex-col items-center gap-3">
        <div className="flex items-center justify-center h-14 w-14 rounded-full bg-primary/15 text-coentro">
          <Upload className="h-7 w-7" />
        </div>
        <div className="text-base">
          <span className="text-coentro font-semibold hover:underline">Escolher arquivo</span>
          <span className="text-muted-foreground"> ou </span>
          <span className="text-coentro font-semibold hover:underline">arraste e solte</span>
        </div>
        <div className="text-xs text-muted-foreground">
          {`(${Object.values(accept)
            .map(value => {
              return value?.map((v: string) => v.toUpperCase())?.join(', ')
            })
            .join(', ')})`}
        </div>
      </div>
    </div>
  )
}
